<script>
export default {
  name: "IconHuman"
};
</script>

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.49999 6.29412C11.125 6.29412 12.4423 5.10899 12.4423 3.64706C12.4423 2.18513 11.125 1 9.49999 1C7.87499 1 6.55768 2.18513 6.55768 3.64706C6.55768 5.10899 7.87499 6.29412 9.49999 6.29412ZM9.49999 2.05882C10.475 2.05882 11.2654 2.7699 11.2654 3.64706C11.2654 4.52422 10.475 5.23529 9.49999 5.23529C8.52499 5.23529 7.7346 4.52422 7.7346 3.64706C7.7346 2.7699 8.52499 2.05882 9.49999 2.05882Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.4"
    />
    <path
      d="M15.3846 7.35297H3.61536C2.64037 7.35297 1.84998 8.06404 1.84998 8.9412C1.84998 9.81836 2.64037 10.5294 3.61536 10.5294H5.38074V17.4118C5.38074 18.2889 6.17113 19 7.14613 19C8.12112 19 8.91151 18.2889 8.91151 17.4118V14.7647H10.0884V17.4118C10.0884 18.2889 10.8788 19 11.8538 19C12.8288 19 13.6192 18.2889 13.6192 17.4118V10.5294H15.3846C16.3596 10.5294 17.15 9.81836 17.15 8.9412C17.15 8.06404 16.3596 7.35297 15.3846 7.35297ZM15.3846 9.47061H12.4423V17.4118C12.4423 17.7042 12.1788 17.9412 11.8538 17.9412C11.5288 17.9412 11.2654 17.7042 11.2654 17.4118V13.7059H7.73459V17.4118C7.73459 17.7042 7.47113 17.9412 7.14613 17.9412C6.82113 17.9412 6.55767 17.7042 6.55767 17.4118V9.47061H3.61536C3.29036 9.47061 3.0269 9.23359 3.0269 8.9412C3.0269 8.64882 3.29036 8.41179 3.61536 8.41179H15.3846C15.7096 8.41179 15.9731 8.64882 15.9731 8.9412C15.9731 9.23359 15.7096 9.47061 15.3846 9.47061Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.4"
    />
  </svg>
</template>
